import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG } from '../app-config';
import { IProductRepository } from './Iproduct.repository';
import { ApiResponse, Plate, PlateSearchDictionary, PlateSearchFilters, ScrewList } from './models';


@Injectable({ providedIn: 'root' })
export class ProductRepository implements IProductRepository {

	private readonly httpClient = inject(HttpClient);
	private readonly config = inject(APP_CONFIG);

	
	getPlateList(filters: PlateSearchFilters): Observable<ApiResponse<Plate[]>> {
		return this.httpClient.post<ApiResponse<Plate[]>>(this.config.domainRayAPI + '/api/Products/GetPlateList', filters);
	}

	getDictionary(filters: PlateSearchDictionary): Observable<ApiResponse<string[]>> {
		return this.httpClient.post<ApiResponse<string[]>>(this.config.domainRayAPI + '/api/Products/GetDictionary', filters);
	}

	getScrewList(plateId: string, extensions: boolean): Observable<ApiResponse<ScrewList>> {
		const params = new HttpParams().set('id', plateId).set('ext', extensions);
		return this.httpClient.get<ApiResponse<ScrewList>>(this.config.domainRayAPI + '/api/Products/ScrewList', { params });
	}
}
